import { BusinessDataType } from '../context/BusinessContext'
import { FiltersType } from '../context/CommonContext'

const businessFilter = (businessData: BusinessDataType, filters: FiltersType) => {
    return {
        pipelines: businessData.pipelines
            .map(pipeline => ({
                ...pipeline,
                steps: pipeline.steps
                    .map(step => ({
                        ...step,
                        business: step.business.filter(business => {
                            //? Filtro search
                            const matchesSearch = filters.search
                                ? [business.title, business.subtitle, business.value]
                                      .filter(Boolean)
                                      .some(
                                          field => field && field.toLowerCase().includes(filters.search.toLowerCase())
                                      )
                                : true
                            //? Filtro targets
                            const matchesTargets =
                                filters.targets.length > 0
                                    ? business.targets?.some(target =>
                                          filters.targets.some(
                                              f =>
                                                  f.id === target.id ||
                                                  f.label.toLowerCase() === target.label.toLowerCase()
                                          )
                                      )
                                    : true

                            return matchesSearch && matchesTargets
                        })
                    }))
                    .filter(step => step.business.length > 0) // Remove steps sem negócios após filtro
            }))
            .filter(pipeline => pipeline.steps.length > 0) // Remove pipelines sem steps após filtro
    }
}

export { businessFilter }
